import React, {useEffect, useState} from "react";
import {FormProvider, useForm, useFormContext} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {
  convertToString,
  dateToStringFormat,
  getFechaToCalendar,
  getFechaToCalendarRange,
  validArray
} from "../../../util/functions";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {isObject} from "../../../util/is";
import {portafolioService} from "../../../services/apiPortafolios";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {Colors} from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import {
  classResponsiveForm, classResponsiveFormDoubleWidth, classResponsiveFormDoubleWidthHeader,
  classResponsiveFormWidthHeader,
  ERRORFIELDREQUIRED,
  optionsEstados
} from "../../../data/ConstantForm";
import {CalendarFormRange} from "../../../components/ComponentesFormularios/CalendarForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import {modalCRUDService} from "../../../services/modalCRUDService";



const FormCRUDPortafoliosMateriales = ({properties, isAddMode, isEditing}) => {


  const {  methods, data, params } = properties;
  const {  control, getValues, setValue } = methods;
  const dispatch = useDispatch();
  const generalServicesState = useSelector( state => state.generalServices );
  const methodsCreacion = useForm({
    defaultValues: {
      idPortafolio: isAddMode ? "" : data?.idPortafolio,
      nombreSubPortafolio: isAddMode ? "" : data?.nombreSubPortafolio,
      dtIngSal: isAddMode ? getFechaToCalendarRange(dateToStringFormat(new Date()),'2200-12-31')
        : getFechaToCalendarRange(dateToStringFormat(getFechaToCalendar(data?.dtIni)),dateToStringFormat(getFechaToCalendar(data?.dtFin))),
      idSegmento: isAddMode ? "" : data?.idSegmento,
      idModeloAtencion: isAddMode ? "" : data?.idModeloAtencion,
      idCiudad: isAddMode ? "" : data?.idCiudad,
      idDepartamento: isAddMode ? "" : data?.idDepartamento,
      estado: isAddMode ? "1" : data?.estado
    }
  });
  const { setValue: setValueCreacion, control: controlCreacion, formState: { errors: errorCreacion }, handleSubmit: handleSubmitCreacion, reset: resetCreacion} =
    methodsCreacion;


  /*useEffect(() => {

      let arrPortafolios = validArray(generalServicesState?.arrPortafolios).slice();
      let segmento = validArray(getValues("segmento"));
      let modeloAtencion = validArray(getValues("modeloAtencion"));
      let departamento = getValues("departamento");
      let ciudad = getValues("ciudad");

      let arrFilter = arrPortafolios.filter(x =>
        segmento?.find(seg => convertToString(seg.id).toUpperCase() === convertToString(x.segmento).toUpperCase()) ||
        modeloAtencion?.find(mdla => convertToString(mdla.id).toUpperCase() === convertToString(x.modeloAtencion).toUpperCase()) ||
        x?.departamento?.toString()?.toUpperCase() === departamento?.id?.toString()?.toUpperCase() ||
        x?.ciudad?.toString()?.toUpperCase() === ciudad?.id?.toString()?.toUpperCase());

      ///AQUI
      Emitter.emit(ConstantEventEmitter.eventUpdateOptionsPortafoliosComerciales, arrFilter);

  },[generalServicesState])*/


  const onSuccessSubmit = data => {

    data.dtIngreso = dateToStringFormat(data.dtIngSal[0]);
    data.dtSalida = dateToStringFormat(data.dtIngSal[1]);
    data.idSegmento = isObject(data.idSegmento) ? data.idSegmento.id : data.idSegmento;
    data.idModeloAtencion = isObject(data.idModeloAtencion) ? data.idModeloAtencion.id : data.idModeloAtencion;
    data.idDepartamento = isObject(data.idDepartamento) ? data.idDepartamento.id : data.idDepartamento;
    data.idCiudad = isObject(data.idCiudad) ? data.idCiudad.id : data.idCiudad;
    data.accion = isAddMode ? "C" : "A";
    data.jsItems = [{
      idRecurso: data.idPortafolio,
      nmRecurso: data.nombreSubPortafolio
    }]

    portafolioService.setCrudSubPortafolioSingle(data).then(
      response => {

        const { status, msg, data: datos, existe } = response;

        if(status){

          if(existe){
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ya existe un portafolio con ese identificador" } });
          }
          else{
            dispatch({ type: 'setStateGeneralServices', generalServices: {
                ...generalServicesState,
                arrPortafolios : validArray(datos?.arrPortafolios),
                arrSubPortafolios : validArray(datos?.arrSubPortafolios)
              }});

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

            if(!isAddMode){
              const rowNode = params.api.getRowNode(params.node.id);
              rowNode.setDataValue("estado", data.estado);
              rowNode.setDataValue("portafolioMaterial", data.nombreSubPortafolio);
            }


            resetCreacion({
              idPortafolio: "",
              nombreSubPortafolio: "",
              dtIngSal: getFechaToCalendarRange(dateToStringFormat(new Date()),'2200-12-31'),
              idSegmento: "",
              idModeloAtencion: "",
              idCiudad: "",
              idDepartamento: "",
              estado: "1"
            })


            modalCRUDService.clear();

          }

        }
        else{
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
        }

      },
      error => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
      }
    )


  }

  const onErrorSubmit = errors => {

  }

  const handleCancelar = () => {


    resetCreacion({
      idPortafolio: "",
      nombreSubPortafolio: "",
      dtIngSal: getFechaToCalendarRange(dateToStringFormat(new Date()),'2200-12-31'),
      idSegmento: "",
      idModeloAtencion: "",
      idCiudad: "",
      idDepartamento: "",
      estado: "1"
    })

    modalCRUDService.clear();


  }

  return(

      <div>

        <div className="d-flex justify-content-end align-items-center">
            <div className="d-flex align-items-center">
              <Tooltip title="Cancelar" aria-label="cancelar">
                <a onClick={() => handleCancelar()} className="icon-container-actions d-flex">
                  <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                  <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times fa-2x"/>
                </a>
              </Tooltip>
              <Tooltip title="Guardar" aria-label="guardar">
                <a onClick={handleSubmitCreacion(onSuccessSubmit, onErrorSubmit)} className="icon-container-actions d-flex mr-0">
                  <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                  <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                </a>
              </Tooltip>
            </div>
        </div>

        <div className="row mx-1 align-items-center mt-3" >

          <FormProvider { ...methodsCreacion }>

            <InputForm inputProps={{ control: controlCreacion }} disabled={!isEditing} readOnly={isEditing && !isAddMode} identificador="idPortafolio" label="ID Portafolio"
                       placeholder="Ej: 123" required={true} type="text" className={`${classResponsiveForm}`}
                       customError={errorCreacion.idPortafolio ? ERRORFIELDREQUIRED : null} />

            <InputForm inputProps={{ control: controlCreacion }} disabled={!isEditing} identificador="nombreSubPortafolio" label="Nombre Portafolio"
                       placeholder="Ej: Portafolio X" required={true} type="text" className={`${classResponsiveFormDoubleWidth}`}
                       customError={errorCreacion.nombreSubPortafolio ? ERRORFIELDREQUIRED : null} />

            <CalendarFormRange inputProps={{control: controlCreacion}} disabled={!isEditing} identificador="dtIngSal" required={true}  label="Fecha Ingreso - Salida"
                               className={`w-auto px-2`}
                               customError={errorCreacion.dtIngSal ? ERRORFIELDREQUIRED : null}/>

            <RadioButtonForm inputProps={{ control: controlCreacion }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                             defaultValue="1" label="Estado" className={`w-auto px-2`}
                             customError={errorCreacion.estado ? ERRORFIELDREQUIRED : null} />


          </FormProvider>

        </div>

      </div>

  )


}

export default FormCRUDPortafoliosMateriales;
